(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sculture-limited-sale"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sculture-limited-sale')) {
    customElements.define('sculture-limited-sale', class extends HTMLElement {
      connectedCallback() {
        this.preview = this.dataset.preview === 'true';
        this.startTime = this.preview ? Date.now() : Number(this.dataset.start) * 1000;
        this.endTime = this.preview ? this.startTime + (3 * 3600 + 33 * 60 + 33) * 1000 : Number(this.dataset.end) * 1000;
        this.copyButton = this.querySelector('[data-copy]');
        this.defaultCopyLabel = this.copyButton.textContent.trim();
        this.onCopy = () => this.copyCode();
        this.copyButton.addEventListener('click', this.onCopy);
        this.tick();
        this.timerInterval = window.setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        window.clearInterval(this.timerInterval);
        window.clearTimeout(this.copyResetTimeout);
        this.copyButton?.removeEventListener('click', this.onCopy);
      }
      tick() {
        const now = Date.now();
        const visible = this.preview || (Number.isFinite(this.startTime) && Number.isFinite(this.endTime) && now >= this.startTime && now < this.endTime);
        this.hidden = !visible;
        if (!visible) {
          if (!this.preview && now >= this.endTime) window.clearInterval(this.timerInterval);
          return;
        }
        const seconds = Math.max(0, Math.ceil((this.endTime - now) / 1000));
        const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor(seconds % 3600 / 60)).padStart(2, '0');
        const remainingSeconds = String(seconds % 60).padStart(2, '0');
        const hourTens = this.querySelector('[data-hour-tens]');
        hourTens.textContent = hours.slice(0, -1);
        hourTens.classList.toggle('sc-limited-sale__digit--multi', hours.length > 2);
        this.querySelector('[data-hour-ones]').textContent = hours.slice(-1);
        this.querySelector('[data-minute-tens]').textContent = minutes[0];
        this.querySelector('[data-minute-ones]').textContent = minutes[1];
        this.querySelector('[data-second-tens]').textContent = remainingSeconds[0];
        this.querySelector('[data-second-ones]').textContent = remainingSeconds[1];
      }
      async copyCode() {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(this.dataset.code);
          } else {
            const input = document.createElement('textarea');
            input.value = this.dataset.code;
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            const copied = document.execCommand('copy');
            input.remove();
            if (!copied) throw new Error('Clipboard unavailable');
          }
          this.copyButton.textContent = this.dataset.copied;
          this.querySelector('[data-copy-status]').textContent = this.dataset.copied;
          window.clearTimeout(this.copyResetTimeout);
          this.copyResetTimeout = window.setTimeout(() => { this.copyButton.textContent = this.defaultCopyLabel; }, 2500);
        } catch (error) {
          this.querySelector('[data-copy-status]').textContent = this.dataset.copyFailed;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
